"use strict";

import axios from "axios";
import store from "@/store";
import router from "@/router";

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.withCredentials = true;

const _axios = axios.create();

_axios.interceptors.request.use(
  function(config) {
    return config;
  },
  function(error) {
    return Promise.reject(error);
  },
);

_axios.interceptors.response.use(
  function(response) {
    return response;
  },
  async function(error) {
    const { config, response } = error;

    if (response?.status === 401) {
      const publicRoutes = ["Login", "ForgottenPassword", "password-reset", "CompleteRegistration", "TokenExpired"];
      if (!publicRoutes.includes(router.currentRoute.value.name)) {
        store.commit("clear");
        _axios.defaults.headers.common["Authorization"] = "";
        router.push("/login");
      }
      return Promise.reject(error);
    }

    if (
      response?.status === 419 &&
      !config._csrfRetry &&
      !config.url?.includes("/sanctum/csrf-cookie")
    ) {
      config._csrfRetry = true;
      await axios.get(process.env.APP_API_URL + "/sanctum/csrf-cookie");
      return _axios(config);
    }

    return Promise.reject(error);
  },
);

export { _axios };

export default {
  install: app => {
    app.config.globalProperties.$axios = _axios;
  },
};
